/**
 * Потолок файла в загрузках УЧЕНИКА — фото-ответ в тесте (аудит безопасности 31.10.2026, R33).
 *
 * Сервер режет такой файл ещё в потоке (WIKI_LEARNER_UPLOAD_MAX_BYTES = 25 МБ, backend
 * wiki-upload.storage.ts) и отвечает 413 «File too large» по-английски. Здесь — то же число, чтобы ученик
 * увидел понятный отказ до отправки, а не после загрузки большого файла. Форма практики режет раньше —
 * 20 МБ (PracticalTask.tsx).
 */
export const LEARNER_PHOTO_MAX_MB = 25;

/** Отказ ученику, когда фото не проходит по размеру. */
export const LEARNER_PHOTO_TOO_BIG = `Фото больше ${LEARNER_PHOTO_MAX_MB} МБ — снимите в обычном качестве`;

/** null — файл подходит по размеру; иначе текст отказа (до отправки на сервер). */
export function learnerPhotoSizeError(file: { size: number }): string | null {
  return file.size > LEARNER_PHOTO_MAX_MB * 1024 * 1024 ? LEARNER_PHOTO_TOO_BIG : null;
}

/** Текст ошибки загрузки фото: 413 — понятно по-русски, иначе message сервера, иначе код ответа. */
export function attemptPhotoErrorText(status: number, serverMessage?: string | string[] | null): string {
  if (status === 413) return LEARNER_PHOTO_TOO_BIG;
  if (serverMessage) return Array.isArray(serverMessage) ? serverMessage.join(', ') : serverMessage;
  return `Ошибка загрузки (${status})`;
}
